<template>
    <div class="dci__warning">
        <div class="dci__warning__body">
            <span class="sg-vrm-icon_012_alarm-32px dci__warning__icon"></span>
            <slot></slot>
        </div>
        <button class="sg-btn sg-element sg-grey" @click="$emit('cancel')">
            {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
        </button>
        <button class="sg-btn sg-element sg-blue" @click="$emit('confirm')">
            {{ $t('common.confirm', { i18nFallback: 'Confirm' }) }}
        </button>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ChangeWarning extends Vue {}
</script>
